function init() {
	$('.blog__item--dropdown .blog__item-btn').on('click', function () {
		$(this).closest('.blog__item--dropdown').find('.blog__item-list').slideToggle();
		$(this).closest('.blog__item--dropdown').toggleClass('active');
	});

	const sidebarItems = $('.blog__item:not(.blog__item--dropdown), .blog__item-list-item');

	sidebarItems.each((i, item) => {
		$(item).on('click', function () {
			if ($(this).hasClass('active')) {
				return;
			}
			sidebarItems.removeClass('active');
			$(this).addClass('active');
			$('.blog__content-item').hide(0);
			$('.blog__content-item').eq(i).fadeIn(300);
		});
	});

	$(sidebarItems[0]).addClass('active');
	$('.blog__content-item').eq(0).fadeIn(300);
	if ($(sidebarItems[0]).closest('.blog__item--dropdown').length) {
		$(sidebarItems[0]).closest('.blog__item-list').slideDown();
		$(sidebarItems[0]).closest('.blog__item--dropdown').addClass('active');
	}

	// юридическая информация
	$('.legal__dropdown .legal__dropdown-btn').on('click', function () {
		$(this).closest('.legal__dropdown').find('.legal__dropdown-list').slideToggle();
		$(this).closest('.legal__dropdown').toggleClass('active');
	});

	const sidebarLegalItems = $('.legal__dropdown-list-item');

	sidebarLegalItems.each((i, item) => {
		$(item).on('click', function () {
			if ($(this).hasClass('active')) {
				return;
			}
			sidebarLegalItems.removeClass('active');
			$(this).addClass('active');
			$('.legal__content-item').hide(0);
			$('.legal__content-item').eq(i).fadeIn(300);
		});
	});

	$('.legal__dropdown').eq(0).addClass('active');
	$('.legal__content-item').eq(0).fadeIn(300);
	$('.legal__dropdown').eq(0).find('.legal__dropdown-list').slideDown();
	$('.legal__dropdown').eq(0).find('.legal__dropdown-list-item').eq(0).addClass('active');

	const blog = document.querySelector('.blog');
	if (blog) {
		if (document.documentElement.clientWidth < 768) {
			const allItems = document.querySelectorAll('.blog__item');
			const allItemsContent = document.querySelectorAll('.blog__item-content');
			const tabsContent = document.querySelector('.blog__content');
			const allContent = document.querySelectorAll('.blog__content-item');

			tabsContent.innerHTML = '';

			allItems.forEach((ele) => {
				ele.classList.remove('active');
			});

			allItems.forEach((el) => {
				el.querySelectorAll('.blog__item-click').forEach((elems) => {
					elems.addEventListener('click', () => {
						let html;

						console.log(el);

						allItems.forEach((ele) => {
							ele.classList.remove('active');
						});

						el.classList.add('active');

						allItemsContent.forEach((element) => {
							element.innerHTML = '';
						});

						allContent.forEach((it) => {
							if (it.getAttribute('data-content') === elems.getAttribute('data-content')) {
								html = String(it.innerHTML);
							}
						});

						el.querySelector('.blog__item-content').innerHTML = html;
					});
				});
			});
		}
	}
}

export default {
	init,
};
